import { Slash } from "lucide-react";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import Icons from "../ui/icons";

type BreadcrumbItemType = {
  name: string;
  path?: string;
};

interface CustomBreadcrumbProps {
  items: BreadcrumbItemType[];
}

export function CustomBreadcrumb({ items }: CustomBreadcrumbProps) {
  return (
    <div className="flex flex-col gap-5">
      <Breadcrumb>
        <BreadcrumbList className="flex gap-4 items-center">
          {items.map((item, index) => (
            <div key={index} className="flex items-center gap-4">
              <BreadcrumbItem>
                {index === items.length - 1 ? (
                  <BreadcrumbPage className=" text-white">
                    {item.name}
                  </BreadcrumbPage>
                ) : item.path ? (
                  <BreadcrumbLink href={item.path} className="text-gray-500">
                    {item.name}
                  </BreadcrumbLink>
                ) : (
                  <span className="text-white">{item.name}</span>
                )}
              </BreadcrumbItem>
              {index < items.length - 1 && (
                <BreadcrumbSeparator className="mx-1">
                  <Icons.arrowleft />
                </BreadcrumbSeparator>
              )}
            </div>
          ))}
        </BreadcrumbList>
      </Breadcrumb>

      <h1 className="text-3xl text-white">
        {items[items.length - 1]?.name}
      </h1>
    </div>
  );
}
